import { useSyncExternalStore } from "react";

export const useMediaQuery = (query: string) => {
  return useSyncExternalStore(
    (onChange) => {
      const mediaQuery = window.matchMedia(query);
      mediaQuery.addEventListener("change", onChange);
      return () => mediaQuery.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
};

export default useMediaQuery;
